"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpinnerIcon = exports.UnknownIcon = exports.FailedIcon = exports.SuccessIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const icons_1 = require("../../atoms/icons");
const faCheckCircle_1 = require("@fortawesome/free-solid-svg-icons/faCheckCircle");
const faTimesCircle_1 = require("@fortawesome/free-solid-svg-icons/faTimesCircle");
const faSpinner_1 = require("@fortawesome/free-solid-svg-icons/faSpinner");
const SuccessIcon = ({ isMobile }) => {
    return ((0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "circleSmall", icon: faCheckCircle_1.faCheckCircle, color: "green-white", size: isMobile ? "sm" : "1x" }, void 0));
};
exports.SuccessIcon = SuccessIcon;
const FailedIcon = ({ isMobile }) => {
    return ((0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "circleSmall", icon: faTimesCircle_1.faTimesCircle, color: "pink-white", size: isMobile ? "sm" : "1x" }, void 0));
};
exports.FailedIcon = FailedIcon;
const SpinnerIcon = ({ isMobile }) => {
    return ((0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "circleSmall", icon: faSpinner_1.faSpinner, color: "blue-white", size: isMobile ? "sm" : "1x" }, void 0));
};
exports.SpinnerIcon = SpinnerIcon;
const UnknownIcon = ({ isMobile }) => {
    return ((0, jsx_runtime_1.jsx)(UnknownIconWrapper, { isMobile: isMobile, children: (0, jsx_runtime_1.jsx)(IconBase, { isMobile: isMobile }, void 0) }, void 0));
};
exports.UnknownIcon = UnknownIcon;
const UnknownIconWrapper = styled_components_1.default.span `
  display: inline-block;

  & > div {
    border: 1px solid ${({ theme }) => theme.colors.greyLighten70};
    background-color: ${({ theme }) => theme.colors.silverLighten40};
  }
`;
const IconBase = styled_components_1.default.div `
  border-radius: 50%;
  height: ${({ isMobile }) => (isMobile ? 14 : 16)}px;
  width: ${({ isMobile }) => (isMobile ? 14 : 16)}px; ;
`;
//# sourceMappingURL=Icons.js.map